import { MembershipGroup, MembershipGroupResponse } from "@/types/system-setting/membership";
import { apiSlice } from "@/redux/apiSlice";
import { ApiResponse } from "@/types";

interface TransformedGroup {
  value: number;
  label: string;
  id?: number
}

export const Groups = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getGroup: builder.query<TransformedGroup[], number>({
        query: (org_id) => ({
          url: `/group?org_id=${org_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Groups"],
        transformResponse: (resp: MembershipGroupResponse[]) => {
          return resp.map((item) => ({
            value: item.id,
            label: item.name,
            id: item.id
          }));
        },
      }),
      createGroup: builder.mutation<MembershipGroupResponse, MembershipGroup>({
        query: (membershipsydata) => ({
          url: `/group`,
          method: "POST",
          body: membershipsydata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Groups"],
      }),
      updateGroup: builder.mutation<MembershipGroupResponse, MembershipGroup>({
        query: (groupdata) => ({
          url: `/group`,
          method: "POST",
          body: groupdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Groups"],
      }),
      deleteGroup: builder.mutation<ApiResponse, number>({
        query: (group_id) => ({
          url: `/group/${group_id}`,
          method: "POST",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Groups"],
      }),
      getGroupById: builder.mutation<MembershipGroupResponse, number>({
        query: (group_id) => ({
          url: `/group/${group_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Groups"],
      })
    };
  },
});

export const {
  useGetGroupQuery,
  useCreateGroupMutation,
  useUpdateGroupMutation,
  useDeleteGroupMutation,
  useGetGroupByIdMutation
} = Groups;
